<script>
export default {
  name: 'Thd',
  props: ['stableData']
}
</script>

<template>
  <div class="pg">
    <!--      谐波畸变率-->
    <div class="dataItems">
      <div class="title">谐波畸变率(THD)</div>
      <div class="dataItem">
        <div class="dataName">
          <div class="dataTitle">电气量</div>
          <div class="dataNvItem">Ua</div>
          <div class="dataNvItem">Ub</div>
          <div class="dataNvItem">Uc</div>
          <div class="dataNvItem">Uab</div>
          <div class="dataNvItem">Ubc</div>
          <div class="dataNvItem">Uca</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">THD-F</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ua_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ub_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uc_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uab_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ubc_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uca_f : 0).toFixed(2) }}%</div>
        </div>
        <div class="dataValue" style="border-right: 1px solid black;">
          <div class="dataTitle">THD-R</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ua_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ub_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uc_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uab_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ubc_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_uca_r : 0).toFixed(2) }}%</div>
        </div>
        <div class="dataName" style="margin-left: 10px">
          <div class="dataTitle">电气量</div>
          <div class="dataNvItem">Ia</div>
          <div class="dataNvItem">Ib</div>
          <div class="dataNvItem">Ic</div>
          <div class="dataNvItem">In</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">THD-F</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ia_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ib_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ic_f : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_in_f : 0).toFixed(2) }}%</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">THD-R</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ia_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ib_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_ic_r : 0).toFixed(2) }}%</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.thd_in_r : 0).toFixed(2) }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
</style>



// WEBPACK FOOTER //
// src/pages/Stable/Thd/Thd.vue